import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {MenuItem, Typography, BaseSelectProps} from '@mui/material'
import {CommonProps} from '@mui/material/OverridableComponent'
import {theme} from '@styles'

import React, {ReactNode} from 'react'

import {LabeledWrapper} from '../wrapper-with-label'
import {MenuItemContent, StyledSelect, iconStyle} from './style'

export type MultiDropdownItem = {
  value: string
  label: string
  icon?: ReactNode
}

export interface MultiDropdownProps {
  items: MultiDropdownItem[]
  renderValue?: () => JSX.Element
  customStyle?: CommonProps['style']
  label?: string
  value?: string[]
  hideBorder?: boolean
  width?: number
  tooltip?: string
}

/**
 * Multi Dropdown component
 */
export function MultiDropdown(props: MultiDropdownProps & BaseSelectProps) {
  const {label, hideBorder, width, items, renderValue, error, value, disabled, tooltip, ...rest} = props

  const defaultRenderValue = () => {
    return (
      <Typography textAlign={'start'} color={!value ? theme.palette.grey[200] : 'initial'} variant="body2">
        {!value
          ? label
          : items
              .filter(item => value.includes(item.value))
              .map(item => item.label)
              .join(', ')}
      </Typography>
    )
  }

  return (
    <LabeledWrapper width={width} label={label} tooltip={tooltip}>
      <StyledSelect
        multiple
        IconComponent={() =>
          error ? (
            <ErrorOutlineRoundedIcon style={{color: theme.palette.error.main, paddingRight: 15}} />
          ) : disabled ? (
            <></>
          ) : (
            <ExpandMoreIcon style={iconStyle} />
          )
        }
        hideBorder={hideBorder}
        displayEmpty
        disabled={disabled}
        value={value}
        renderValue={renderValue ?? defaultRenderValue}
        {...rest}
      >
        {items?.map((item, index) => {
          const {value, label: itemLabel, icon} = item
          return (
            <MenuItem key={`${label}-dropdown-item-${index}`} value={value}>
              <MenuItemContent>
                {itemLabel}
                {icon}
              </MenuItemContent>
            </MenuItem>
          )
        })}
      </StyledSelect>
    </LabeledWrapper>
  )
}
